import React, { useEffect, useState } from 'react';
import { IonIcon, IonModal, IonContent, IonText, IonButton } from '@ionic/react';
import './WeatherBadge.css';
import weatherService, {WeatherData} from "../services/WeatherService";
import {getWeatherInfo} from "../utils/WeatherCodes";
import {createTapHandlers} from "../utils/TapHandlers";

const WeatherBadge: React.FC = () => {
  const [weather, setWeather] = useState<WeatherData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    let cancelled = false;

    weatherService
      .getHavaDurumu()
      .then((data) => {
        if (!cancelled) setWeather(data);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  // Yükleniyor ya da hata varsa ana sayfayı bozmadan sessizce hiçbir şey gösterme
  if (loading || error || !weather) {
    return null;
  }

  const current = getWeatherInfo(weather.current.weatherCode);

  return (
    <>
      <div
        className="weather-badge"
        {...createTapHandlers(() => setIsModalOpen(true))}
        role="button"
        aria-label="Hava durumu detayını göster"
      >
        <IonIcon icon={current.icon} className="weather-badge-icon" />
        <span className="weather-badge-temp">{Math.round(weather.current.temperature)}°</span>
      </div>

      <IonModal
        isOpen={isModalOpen}
        onDidDismiss={() => setIsModalOpen(false)}
        initialBreakpoint={0.55}
        breakpoints={[0, 0.55, 0.9]}
      >
        <IonContent className="ion-padding weather-modal-content">
          <div className="weather-modal-header">
            <IonIcon icon={current.icon} className="weather-modal-icon" />
            <div>
              <h1 className="weather-modal-temp">{Math.round(weather.current.temperature)}°</h1>
              <IonText color="medium">{current.label}</IonText>
            </div>
          </div>

          <div className="weather-modal-details">
            <div className="weather-detail-item">
              <IonText color="medium">Hissedilen</IonText>
              <strong>{Math.round(weather.current.feelsLike)}°</strong>
            </div>
            <div className="weather-detail-item">
              <IonText color="medium">Nem</IonText>
              <strong>%{weather.current.humidity}</strong>
            </div>
            <div className="weather-detail-item">
              <IonText color="medium">Rüzgar</IonText>
              <strong>{Math.round(weather.current.windSpeed)} km/s</strong>
            </div>
          </div>

          <div className="weather-forecast-list">
            {weather.daily.map((day) => {
              const info = getWeatherInfo(day.weatherCode);
              const dayLabel = new Date(day.date).toLocaleDateString('tr-TR', { weekday: 'short' });
              return (
                <div className="weather-forecast-item" key={day.date}>
                  <span className="weather-forecast-day">{dayLabel}</span>
                  <IonIcon icon={info.icon} className="weather-forecast-icon" />
                  <span className="weather-forecast-temp">
                    <strong>{Math.round(day.max)}°</strong> / {Math.round(day.min)}°
                  </span>
                </div>
              );
            })}
          </div>

          <IonButton expand="block" fill="clear" onClick={() => setIsModalOpen(false)}>
            Kapat
          </IonButton>
        </IonContent>
      </IonModal>
    </>
  );
};

export default WeatherBadge;
